import { createAsyncThunk } from "@reduxjs/toolkit";

import { updateOrganizationProject } from "Api/organizations/projects/updateOrganizationProject.request";
import { OrganizationProject } from "Api/organizations/projects/OrganizationProjects.types";
import { validateAPIError } from "Api/utils";
import { organizationByDescriptionIdSelector } from "Reducers/organization/organization";

import type { AsyncThunkOptionType } from "Reducers/types";

// PATCHes the OrganizationProjects endpoint (plan changes, ...). Replaces the
// subscription PATCH the plan form used before the subscription endpoint's
// deprecation.
export const updateProject = createAsyncThunk<
  OrganizationProject,
  {
    organizationId: string;
    projectId: string;
    data: Parameters<typeof updateOrganizationProject>[0]["data"];
  },
  AsyncThunkOptionType
>(
  "app/organization/update_project",
  async (
    { organizationId, projectId, data },
    { rejectWithValue, getState }
  ) => {
    try {
      const organization = organizationByDescriptionIdSelector(getState(), {
        organizationDescriptionId: organizationId
      });

      if (!organization) {
        return rejectWithValue("Organization does not exist");
      }

      const project = await updateOrganizationProject({
        organizationId: organization.id,
        projectId,
        data
      });

      return project;
    } catch (err: unknown) {
      return rejectWithValue(validateAPIError(err));
    }
  }
);
